export default __webpack_public_path__ + "static/media/Shape 65.a808a4ad.svg";